module.exports = __webpack_public_path__ + "static/media/night2.84e7b5ba.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/night2.jpeg
// module id = 25
// module chunks = 0